module.exports = __webpack_public_path__ + "static/media/bell.7a486603.svg";